import * as React from "react";

import { PanelType } from "../Panel/PanelTypes";
import { ScrollToProvider } from "../../Internals/Contexts/ScrollToContext";
import { noop } from "../../../../../Common/TypingUtils";

import * as styles from "./PlainForm.styles";

export interface PlainFormProps {
    children: React.ReactNode;
    padding?: string | number;
    setPanelState: (panelState: PanelType) => void;
}

export class PlainForm extends React.Component<PlainFormProps> {
    public componentWillMount(): void {
        this.props.setPanelState("hide");
    }

    public render(): JSX.Element {
        return (
            <ScrollToProvider value={noop}>
                <div css={styles.root}>{this.props.children}</div>
            </ScrollToProvider>
        );
    }
}
